import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/ndarray/base/assert/is-allowed-data-type-cast';
import __var_2__ from '@stdlib/ndarray/base/assert/is-buffer-length-compatible';
import __var_3__ from '@stdlib/ndarray/base/assert/is-buffer-length-compatible-shape';
import __var_4__ from '@stdlib/ndarray/base/assert/is-casting-mode';
import __var_5__ from '@stdlib/ndarray/base/assert/is-column-major';
import __var_6__ from '@stdlib/ndarray/base/assert/is-column-major-contiguous';
import __var_7__ from '@stdlib/ndarray/base/assert/is-contiguous';
import __var_8__ from '@stdlib/ndarray/base/assert/is-data-type';
import __var_9__ from '@stdlib/ndarray/base/assert/is-index-mode';
import __var_10__ from '@stdlib/ndarray/base/assert/is-order';
import __var_11__ from '@stdlib/ndarray/base/assert/is-row-major';
import __var_12__ from '@stdlib/ndarray/base/assert/is-row-major-contiguous';
import __var_13__ from '@stdlib/ndarray/base/assert/is-safe-data-type-cast';
import __var_14__ from '@stdlib/ndarray/base/assert/is-same-kind-data-type-cast';
import __var_15__ from '@stdlib/ndarray/base/assert/is-single-segment-compatible';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace ns
*/
var ns = {};

/**
* @name isAllowedDataTypeCast
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/assert/is-allowed-data-type-cast}
*/
setReadOnly( ns, 'isAllowedDataTypeCast', __var_1__);

/**
* @name isBufferLengthCompatible
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/assert/is-buffer-length-compatible}
*/
setReadOnly( ns, 'isBufferLengthCompatible', __var_2__);

/**
* @name isBufferLengthCompatibleShape
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/assert/is-buffer-length-compatible-shape}
*/
setReadOnly( ns, 'isBufferLengthCompatibleShape', __var_3__);

/**
* @name isCastingMode
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/assert/is-casting-mode}
*/
setReadOnly( ns, 'isCastingMode', __var_4__);

/**
* @name isColumnMajor
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/assert/is-column-major}
*/
setReadOnly( ns, 'isColumnMajor', __var_5__);

/**
* @name isColumnMajorContiguous
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/assert/is-column-major-contiguous}
*/
setReadOnly( ns, 'isColumnMajorContiguous', __var_6__);

/**
* @name isContiguous
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/assert/is-contiguous}
*/
setReadOnly( ns, 'isContiguous', __var_7__);

/**
* @name isDataType
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/assert/is-data-type}
*/
setReadOnly( ns, 'isDataType', __var_8__);

/**
* @name isIndexMode
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/assert/is-index-mode}
*/
setReadOnly( ns, 'isIndexMode', __var_9__);

/**
* @name isOrder
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/assert/is-order}
*/
setReadOnly( ns, 'isOrder', __var_10__);

/**
* @name isRowMajor
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/assert/is-row-major}
*/
setReadOnly( ns, 'isRowMajor', __var_11__);

/**
* @name isRowMajorContiguous
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/assert/is-row-major-contiguous}
*/
setReadOnly( ns, 'isRowMajorContiguous', __var_12__);

/**
* @name isSafeDataTypeCast
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/assert/is-safe-data-type-cast}
*/
setReadOnly( ns, 'isSafeDataTypeCast', __var_13__);

/**
* @name isSameKindDataTypeCast
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/assert/is-same-kind-data-type-cast}
*/
setReadOnly( ns, 'isSameKindDataTypeCast', __var_14__);

/**
* @name isSingleSegmentCompatible
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/assert/is-single-segment-compatible}
*/
setReadOnly( ns, 'isSingleSegmentCompatible', __var_15__);


// EXPORTS //
export default ns;

export { __var_1__ as isAllowedDataTypeCast, __var_2__ as isBufferLengthCompatible, __var_3__ as isBufferLengthCompatibleShape, __var_4__ as isCastingMode, __var_5__ as isColumnMajor, __var_6__ as isColumnMajorContiguous, __var_7__ as isContiguous, __var_8__ as isDataType, __var_9__ as isIndexMode, __var_10__ as isOrder, __var_11__ as isRowMajor, __var_12__ as isRowMajorContiguous, __var_13__ as isSafeDataTypeCast, __var_14__ as isSameKindDataTypeCast, __var_15__ as isSingleSegmentCompatible};